import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/input/styles.scss';export default {
  "input": "_input_1dcnw_1",
  "opened": "_opened_1dcnw_20",
  "toggleIcon": "_toggleIcon_1dcnw_25",
  "placeholder": "_placeholder_1dcnw_39",
  "folder": "_folder_1dcnw_46",
  "icon": "_icon_1dcnw_58",
  "tagIcon": "_tagIcon_1dcnw_70"
};